import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"flat":""}},[_c(VRow,{staticClass:"px-4",attrs:{"no-gutters":""}},[(!_vm.hideOffice)?_c(VCol,{staticClass:"px-3",attrs:{"cols":"12","sm":6,"md":4}},[_c('WBDOfficeSelectorFilter',{attrs:{"remote-list":[],"label":'Поиск объектов',"remote-selected-list-list":''},on:{"onOfficeSelectorFilterChange":_vm.onOfficeSelectorFilterChange}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }